import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, BookOpen, Info, MessageCircle, UserPlus } from 'lucide-react';
import { db, auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import './MobileNav.css';

const MobileNav: React.FC = () => {
  const [registrationOpen, setRegistrationOpen] = useState(true);
  const [user, setUser] = useState(auth.currentUser);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    const unsubscribeSettings = onSnapshot(doc(db, 'settings', 'main'), (snap) => {
      if (snap.exists()) {
        setRegistrationOpen(snap.data().registrationOpen !== false);
      }
    });

    return () => {
      unsubscribeAuth();
      unsubscribeSettings();
    };
  }, []);

  return (
    <nav className="mobile-bottom-nav mobile-only">
      <NavLink to="/" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
        <Home size={22} />
        <span>Início</span>
      </NavLink>
      <NavLink to="/publicacoes" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
        <BookOpen size={22} />
        <span>Publicações</span>
      </NavLink>
      
      {registrationOpen && (
        <NavLink to="/inscricao" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
          <UserPlus size={22} />
          <span>Inscrição</span>
        </NavLink>
      )}

      <NavLink to="/sobre-nosotros" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
        <Info size={22} />
        <span>Sobre</span>
      </NavLink>
      <NavLink to="/contacto" className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}>
        <MessageCircle size={22} />
        <span>Contacto</span>
      </NavLink>
    </nav>
  );
};

export default MobileNav;
